import './main.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { useNavigate } from "react-router-dom";
import banner from "./banner.png"
import banner2 from "./banner2.png"

import { Carousel, Divider, Modal, Input, Button, Spin, message } from 'antd';
import logo from '../../images/logo.png'
import { jwtDecode } from 'jwt-decode';
import { setDoc, deleteDoc, onSnapshot } from 'firebase/firestore';
import { shareLinkDoc, SHARE_LINK_FLAG } from '../../funcs/shareLoginLink';

function SignupTwo() {

    // let scopes = "instagram_basic,instagram_content_publish,instagram_manage_comments,instagram_manage_insights,pages_show_list,pages_read_engagement"
    let scopes = "business_basic,business_content_publish,business_manage_comments,business_manage_messages"
    // let appId = "433149449449290"
    let appId = "996086435858506"
    let redirectURL = "https://app.instantdm.com/fb-rdr"
    let url = `https://www.instagram.com/oauth/authorize?client_id=${appId}&redirect_uri=${redirectURL}&response_type=code&scope=${scopes}`



    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const show_ig_connect = urlParams.get('show_ig_connect') || false;


    const [showHelp, setShowHelp] = useState(false);

    const [shareOpen, setShareOpen] = useState(false);
    const [shareLink, setShareLink] = useState(null);
    const [shareStatus, setShareStatus] = useState("pending");
    const [shareBusy, setShareBusy] = useState(false);

    // A client who arrived through a share link shouldn't see the share button.
    const canShare = !!localStorage.getItem("token") && !localStorage.getItem(SHARE_LINK_FLAG);

    const openShareModal = async () => {
        const token = localStorage.getItem("token");
        let decoded = null;
        try { decoded = jwtDecode(token); } catch (e) { }
        if (!decoded?.user_id) {
            message.error("Please log in again to create a share link.");
            return;
        }
        setShareBusy(true);
        try {
            await setDoc(shareLinkDoc(decoded.user_id), {
                token: token,
                user_id: decoded.user_id,
                name: decoded?.name || null,
                show_ig_connect: show_ig_connect != false,
                status: "pending",
                created_at: Date.now(),
            });
            setShareStatus("pending");
            setShareLink(`${window.location.origin}/connect/${decoded.user_id}`);
            setShareOpen(true);
        } catch (err) {
            console.error("share-link create failed", err);
            message.error("Couldn't create the link. Please try again.");
        }
        setShareBusy(false);
    };

    // Agency side of the sync: watch the doc while the modal is open and
    // remove it once the owner has connected.
    useEffect(() => {
        if (!shareOpen || !shareLink) return;
        const id = shareLink.split("/").pop();
        const unsub = onSnapshot(shareLinkDoc(id), (snap) => {
            if (snap.data()?.status === "connected") {
                setShareStatus("connected");
                deleteDoc(shareLinkDoc(id)).catch(() => { });
            }
        }, (err) => console.warn("share-link listen failed", err));
        return unsub;
    }, [shareOpen, shareLink]);

    const copyShareLink = () => {
        navigator.clipboard.writeText(shareLink).then(
            () => message.success("Link copied"),
            () => message.error("Copy failed — select the link and copy it manually")
        );
    };

    useEffect(() => {
        const visitedBefore = localStorage.getItem('visitedBefore');
        if (visitedBefore === 'true') {
            setShowHelp(true);
        } else {
            localStorage.setItem('visitedBefore', 'true');
        }
    }, []);

    const routeChange = () => {
        window.location.assign(url);
    }

    const fbRouteChange = () => {
        // scopes = "instagram_basic,email,instagram_manage_comments,pages_show_list,business_management,instagram_manage_messages,pages_read_engagement,pages_manage_metadata,pages_manage_ads,ads_management,read"

        // ' pages_messaging',
        // ' pages_read_user_content',

        // ' pages_manage_engagement',


        // ' pages_manage_posts',
        scopes = "instagram_basic,pages_manage_engagement,pages_read_user_content,pages_messaging,email,instagram_manage_comments,pages_show_list,business_management,instagram_manage_messages,pages_read_engagement,pages_manage_metadata,ads_read"
        appId = "433149449449290"
        redirectURL = "https://app.instantdm.com/fb-api-rdr"
        let extras = '{"setup":{"channel":"IG_API_ONBOARDING"}}'
        url = `https://www.facebook.com/v20.0/dialog/oauth?client_id=${appId}&display=page&redirect_uri=${redirectURL}&response_type=token&scope=${scopes}`
        window.location.assign(url);
    }

    return (
        <div className='account-setup'>
            <img src="/logo192.png" alt="Logo" style={{ height: '62px', width: '62px' }} />
            <div className='core-div' >
                <div className='flex-space-between'>
                    <div className='header-content' style={{ flex: 1 }}>
                        <h1 style={{ textAlign: "start" }}>{show_ig_connect == false ? "Connect FB Page with IG Account" : "Connect your IG account"}</h1>
                        <p style={{ textAlign: "start" }}>{show_ig_connect == false ? "Connect your Facebook Page that is linked to your Instagram account." : "To Proceed further, please connect your IG account."}</p>
                    </div>
                    <div className='button-left desktop'>

                        {/* <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Watch Video</a> */}
                        {showHelp && <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Need Help?</a>}
                        <div onClick={() => show_ig_connect == false ? fbRouteChange() : routeChange()} className='connect-fb'>{show_ig_connect == false ? "Connect FB Page" : "Connect your IG Account"}</div>
                        {canShare && <div onClick={() => !shareBusy && openShareModal()} className='connect-fb' style={{ background: 'transparent', color: '#1677ff', border: '1px solid #1677ff' }}>{shareBusy ? "Creating link…" : "Share Login Link"}</div>}
                    </div>

                </div>

                <div className='button-row mobile'>
                    <div onClick={() => show_ig_connect == false ? fbRouteChange() : routeChange()} className='connect-fb'>Connect Account</div>
                    {canShare && <div onClick={() => !shareBusy && openShareModal()} className='connect-fb' style={{ background: 'transparent', color: '#1677ff', border: '1px solid #1677ff' }}>{shareBusy ? "Creating link…" : "Share Login Link"}</div>}
                </div>
                <h3>{show_ig_connect == false ? "Steps to connect your FB Page" : "Steps to connect your IG Account"}</h3>

                {show_ig_connect == false ?
                    <div className='steps'>

                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/step1.png" />
                        </div>
                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/step2.png" />
                        </div>
                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/step3.png" />
                        </div>
                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/step4.png" />
                        </div>
                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/step5.png" />
                        </div>
                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/step6.png" />
                        </div>
                    </div>
                    :
                    <div className='steps'>

                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/igstep1.png" />
                        </div>
                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/igstep2.png" />
                        </div>
                        <div className='step'>
                            <img src="https://public-assets.instantdm.com/steps-idm/igstep3.png" />
                        </div>
                    </div>
                }

                <div className='button-row mobile'>

                    <div onClick={() => show_ig_connect == false ? fbRouteChange() : routeChange()} className='connect-fb'>Connect Account</div>
                    <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Watch Video</a>
                    {showHelp && <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Need Help?</a>}
                </div>

            </div>

            <Modal open={shareOpen} onCancel={() => setShareOpen(false)} footer={null} centered>
                {shareStatus === "connected" ? (
                    <div style={{ textAlign: 'center', padding: '10px 0' }}>
                        <div style={{ fontSize: '48px', marginBottom: '12px' }}>🎉</div>
                        <h2 style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: 700 }}>Account connected</h2>
                        <p style={{ color: '#595959', fontSize: '14px', margin: '0 0 20px' }}>The account owner finished connecting. You're all set.</p>
                        <Button type="primary" onClick={() => window.location.assign("/")}>Go to Dashboard</Button>
                    </div>
                ) : (
                    <div style={{ padding: '10px 0' }}>
                        <h2 style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: 700 }}>Share this login link</h2>
                        <p style={{ color: '#595959', fontSize: '14px', margin: '0 0 16px', lineHeight: 1.6 }}>
                            Send this link to the account owner. Opening it logs them into this InstantDM account so they can connect Instagram themselves — no password sharing needed.
                        </p>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                            <Input readOnly value={shareLink || ""} onFocus={(e) => e.target.select()} />
                            <Button type="primary" onClick={copyShareLink}>Copy</Button>
                        </div>
                        <p style={{ color: '#8c8c8c', fontSize: '12px', margin: '0 0 12px' }}>The link stops working once the account is connected, and expires in 7 days.</p>
                        <p style={{ color: '#595959', fontSize: '13px', margin: 0 }}>
                            <Spin size="small" style={{ marginRight: '8px' }} />
                            Waiting for the account owner to connect… this updates automatically.
                        </p>
                    </div>
                )}
            </Modal>
        </div>
    )

}

export default SignupTwo;


{/* <div className='signup'>
            <div className='left-side' style={{overflow:'hidden'}}>
            <Carousel autoplay adaptiveHeight>
                <div>
                <img src={banner} style={{height:'100%' , width:'100%', backgroundColor:'pink'}} />
                </div>
                <div>
                <img src={banner2} style={{height:'100%' , width:'100%', backgroundColor:'red'}} />
                </div>
            </Carousel>
            </div>
            <div className='right-side'>
                <div className='singup-box'>
                    <p className='product-name'>Instant DM</p>
                    <h3 className='hero-text' >One more step <br/> Connect With Instagram</h3> 
                    
                    
                    {show_ig_connect == false ? <div className='fb-btn' style={{backgroundColor:'blue'}} onClick={() => fbRouteChange() }>Continue With Facebook</div> :
                    <div className='fb-btn'  onClick={() => routeChange() }>Continue With Instagram</div>
                    }
                    
                   
                    
                </div>
                
            </div>
        </div> */}